import { FeatureItem } from "../types";
import { FeatureIcon } from "./FeatureIcon";

export const FeatureCard = ({ feature }: { feature: FeatureItem }) => {
  return (
    <article className="feature-card">
      <FeatureIcon name={feature.icon} />
      <h3 className="feature-title">{feature.title}</h3>
      <p className="feature-body">{feature.description}</p>
    </article>
  );
};
